
<div class="loading-screen-wrapper" *ngIf="loading">
  <div class="loading-screen-icon">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
    <br />
    <b>Cargando</b>
  </div>
</div>
